import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { getMeetingsByForm } from "services/api";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import InterviewCalendar from "components/InterviewCalendar";

const MeetingsPage = ({ form, canEdit, adminOrCeo, employeedLoggedId, isFormView = false }) => {
  const [events, setEvents] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchMeetings = async () => {
      try {
        setLoading(true);
        let meetingsData;

        meetingsData = await getMeetingsByForm(form?.id);

        if (meetingsData !== "error") {
          let filteredMeetingsData;
          filteredMeetingsData = meetingsData;

          const allEvents = [];
          // Object.values(meetingsData).forEach((meetingArray) => {
          Object.values(filteredMeetingsData).forEach((meetingArray) => {
            meetingArray.forEach((meeting) => {
              const dateObj = new Date(meeting.meetingDate);
              const endDate = new Date(dateObj.getTime() + 60 * 60000);
              allEvents.push({
                start: dateObj,
                end: endDate, // same as start per your code
                resource: meeting,
                allDay: false,
              });
            });
          });
          setEvents(allEvents);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMeetings();
  }, [form, isFormView]);

  return (
    <Box>
      <InterviewCalendar
        initialEvents={events}
        loading={loading}
        currentDate={currentDate}
        setCurrentDate={setCurrentDate}
        employeedLoggedId={employeedLoggedId}
      />
    </Box>
  );
};

MeetingsPage.propTypes = {
  form: PropTypes.object.isRequired,
  canEdit: PropTypes.bool,
  adminOrCeo: PropTypes.bool,
  employeedLoggedId: PropTypes.string,
  isFormView: PropTypes.bool,
};

export default MeetingsPage;
